import { ChangeDetectorRef, Component, Inject, Input, OnChanges, OnDestroy, OnInit, inject, input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { ReportService } from 'src/app/services/report.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { ForestTreament } from 'src/app/models/forestTreatment.model';
import { TreamentSpecification } from 'src/app/models/forestSpecification.model';
import { Editor, Toolbar } from 'ngx-editor';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { DialogService } from 'src/app/services/dialog.service';
import { UserService } from 'src/app/services/user.service';
import { faEdit, faExclamationCircle, faWarning, faFileCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { EditFundsComponent } from '../edit-funds/edit-funds.component';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs/internal/Subject';
import { AutoSaveComponent } from '../../auto-save/auto-save.component';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBar,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { AuthMethodEnum } from 'src/app/models/enum/auth-method.enum';

interface ReportForestExtras {
  data: any[],
  woData: any[],
  editor: Editor,
  form: FormGroup,
}

@Component({
  selector: 'app-regional-funding',
  templateUrl: './regional-funding.component.html',
  styleUrls: ['./regional-funding.component.scss'],
  standalone: false
})

export class RegionalFundingComponent extends AutoSaveComponent implements OnInit, OnChanges, OnDestroy {
  faEdit = faEdit;
  faExclamationCircle = faExclamationCircle;
  faFileCircleCheck = faFileCircleCheck;

  faWarning = faWarning;
  totalRequested: any = {};

  report = input.required<any>();
  pre_assessment_report: any;
  gis_specialist: any;
  treatmentOptions: any;
  user: any;
  toolbar: Toolbar = APP_CONSTANTS.EDITOR_TOOLBAR;
  @Input() updateReportSubject?: Subject<any>;
  @Input() readySubject!: Subject<boolean>;
  authorizationStatusList: any;

  form = this.formBuilder.group({
    assessment_cost: [0],
  });
  displayedColumns = [
    //'select',
    'treatment',
    'spec_number',
    'spec_name',
    'off_nfs',
    'outside_fire',
    'unit_type',
    'unit_qty',
    'unit_cost',
    'total',
    'authorized_total',
    'authorized_by',
    'authorized_status',
    // 'edit',
  ]
  WO_DisplayedColumns = [
    'treatment',
    'spec_number',
    'spec_name',
    'off_nfs',
    'outside_fire',
    'unit_type',
    'unit_qty',
    'unit_cost',
    'total',
    'authorized_total',
    'authorized_by',
    'authorized_status',
    // 'edit',
  ]
  footerDisplayedColumns = [
    //'select',
    'treatment',
    'total',
    'authorized_total',
    'authorized_by',
  ]
  forestTreatments: any;

  constructor(
    public dialog: MatDialog,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly userService: UserService,
    public readonly toast: ConfirmationToastComponent,
    private readonly dialogService: DialogService,
    private readonly titleService: Title,
    private readonly ref: ChangeDetectorRef,
    private readonly _snackBar: MatSnackBar,
  ) {
    super()
    this.titleService.setTitle("BAER - Regional-Funding")
    this.reportService.getSpecAuthorizedStatusOptions().subscribe((options: any) => {
      this.authorizationStatusList = options;
    });
  }

  updateEditable() {
    if (this.report().authorization_status_id == 3 || this.report().authorization_status_id == 1) { // Review RO Funding
      this.editable = true
    } else {
      this.editable = false
    }

    let regions: string[] = this.user.baer_roles.filter((role: any) => role.baer_role.type == "ROCO").map((role: any) => role.region)

    if (!this.report().forests.some((forest: any) => regions.includes(forest.region))) {
      this.editable = false
    }
    this.loadEditable()
  }

  loadEditable() {
    if (this.editable) {
      this.displayedColumns = [
        'select',
        'treatment',
        'spec_number',
        'spec_name',
        'off_nfs',
        'outside_fire',
        'unit_type',
        'unit_qty',
        'unit_cost',
        'total',
        'authorized_total',
        'authorized_by',
        'authorized_status',
        'edit',
      ]
      this.footerDisplayedColumns = [
        'select',
        'treatment',
        'total',
        'authorized_total',
        'authorized_by',
      ]
    } else {
      this.displayedColumns = [
        'treatment',
        'spec_number',
        'spec_name',
        'off_nfs',
        'outside_fire',
        'unit_type',
        'unit_qty',
        'unit_cost',
        'total',
        'authorized_total',
        'authorized_by',
        'authorized_status',
      ]
      this.footerDisplayedColumns = [
        'treatment',
        'total',
        'authorized_total',
        'authorized_by',
      ]
    }
  }


  load() {
    if (this.report().report_num == 1) this.loadPre(); //only load pre-assessment data on initial
    this.report().forests.forEach((forest: ReportForest & ReportForestExtras) => {
      forest.form = this.formBuilder.group({
        job_code: [forest.job_code?.trim() ?? "", Validators.maxLength(20)],
        regional_authorization_narrative: [this.customATOB(forest.regional_authorization_narrative ?? ""), Validators.maxLength(6000)],
      })
      this.formReady = true
      this.listenForChanges(forest.form);
      forest.editor = new Editor();
    });
    this.dialogService.openSpinner();
    this.reportService.getTreatmentOptions().subscribe((options: any) => {
      this.treatmentOptions = options
      this.form.patchValue({
        assessment_cost: this.report().assessment_cost,
      })
      this.totalRequested = {}
      this.report().forests.forEach((forest: ReportForest & ReportForestExtras) => {
        forest.data = []
        forest.woData = []
        forest.treatments!.forEach((treatment: ForestTreament) => {
          if (this.totalRequested[forest.region!.toString()] === undefined) {
            this.totalRequested[forest.region!.toString()] = 0
          }
          this.setTreatments(treatment, forest);
        })

        this.totalRequested[forest.region!.toString()] += this.forestTotalAuthorized(forest.data)
      });
      this.checkIfAllComplete();
      this.dialogService.closeSpinner();
    });
    this.userService.getUserProfile().then((user) => {
      this.user = user;
      this.updateEditable()
    })
  }

  loadPre() {
    this.reportService.getReportList(this.report().assessment_id, "&relations=forests.treatments.treatment_specifications").subscribe((data: any) => {
      this.pre_assessment_report = data.reports.find((report: any) => report.report_num == 0);
    })
    this.report().users.forEach((user: any) => {
      let skill_found = user.skills.find((skill: any) => skill.skill_id == 4); //GIS
      if (skill_found) this.gis_specialist = user;
    })
  }

  getReportForests(): [ReportForest[], boolean] {
    let reportForests: ReportForest[] = []
    let index = 0;
    let allFieldsFilled = true

    this.report().forests.forEach((forest: ReportForest & ReportForestExtras) => {
      let newForest: ReportForest = {
        forest_id: forest.forest_id,
        job_code: forest.form.controls["job_code"].valid ? forest.form.value.job_code : undefined,
        regional_authorization_narrative: forest.form.controls['regional_authorization_narrative'].valid ? this.customBTOA(forest.form.value.regional_authorization_narrative) : undefined,
      }

      if (newForest.job_code == "") allFieldsFilled = false
      if (newForest.regional_authorization_narrative == "" || newForest.regional_authorization_narrative == null) allFieldsFilled = false

      // Match updates to report object so we don't have to reload the entire report
      if (newForest.job_code) forest.job_code = newForest.job_code
      if (newForest.regional_authorization_narrative) forest.regional_authorization_narrative = newForest.regional_authorization_narrative

      reportForests.push(newForest)

      index += 1
    })

    return [reportForests, allFieldsFilled]
  }


  override save() {
    let [reportForests, allFieldsFilled] = this.getReportForests()

    if (this.checkIfNotNeedToSave(reportForests)) return

    this.reportService.updateReport({
      report_id: this.report().report_id,
      forests: reportForests,
      regional_funding_status_id: allFieldsFilled ? 2 : 1,
    }).subscribe({
      next: (response) => {
        this.postSave()
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
    })
  }

  ngOnChanges() {
    this.load()
  }

  ngOnInit() {
    this.load()
  }

  setTreatments(treatment: any, forest: any) {
    let options = this.treatmentOptions.find((option: any) => option.treatment_option_id == treatment.treatment_option_id)

    treatment.treatment_specifications!.forEach((spec: TreamentSpecification) => {
      // ro_authorized_by_id 1 is "Forward to WO"
      if (options?.code == "M2" || options?.code == "M3" || spec.ro_authorized_by_id == AuthMethodEnum.FOWARD_TO_WO) { // Determine if the spec needs WO approval
        this.WOApproval(forest, options, spec);
      } else {
        this.noWOApproval(forest, options, spec);
      }
    })

    forest.data.sort((a: any, b: any) => a.spec_number < b.spec_number ? -1 : 1);
    forest.data.sort((a: any, b: any) => a.treatment_option < b.treatment_option ? -1 : 1);
  }

  WOApproval(forest: any, options: any, spec: any) {
    forest.woData.push({
      ...spec,

      rowType: "normal-cell",
      type: options?.treatment_type?.treatment_type,
      treatment: options?.treatment_option,
      region: forest.region,
      unit_type: options?.unit_of_measure,
      select: new FormControl(false),
      unit_qty: spec.custom_unit_qty ?? spec.gis_unit_qty,

    })
    if (spec.wo_authorized_by_id == AuthMethodEnum.WO_AUTHORIZED) {
      if (spec.wo_approved_unit_cost != spec.unit_cost || spec.wo_approved_unit_qty != (spec.custom_unit_qty ?? spec.gis_unit_qty)) {
        forest.woData.push({
          rowType: "bonus-top",
          treatment: "Modified Authorization",
          treatment_option: options?.treatment_option,
          spec_number: spec.specification_number,
        }, {
          rowType: "bonus-data bonus-data-end",
          treatment: "# of Units or Unit Cost Modified",
          treatment_option: options?.treatment_option,
          spec_number: spec.specification_number,
          unit_qty: spec.wo_approved_unit_qty,
          unit_cost: spec.wo_approved_unit_cost,
          qty_class: spec.wo_approved_unit_qty == (spec.custom_unit_qty ?? spec.gis_unit_qty) ? undefined : 'yellow',
          cost_class: spec.wo_approved_unit_cost == spec.unit_cost ? undefined : 'yellow',
          hideRequested: true,
          wo_approved_unit_qty: spec.wo_approved_unit_qty,
          wo_approved_unit_cost: spec.wo_approved_unit_cost,
        })
      }
    }
  }

  noWOApproval(forest: any, options: any, spec: any) {
    let mainEntry = {
      region: forest.region,
      rowType: "normal-cell",
      type: options?.treatment_type?.treatment_type,
      treatment: options?.treatment_option,
      treatment_option: options?.treatment_option,
      unit_type: options?.unit_of_measure,
      unit_qty: spec.custom_unit_qty ?? spec.gis_unit_qty,
      select: new FormControl(false),
      ...spec
    }
    forest.data.push(mainEntry)
    if (spec.ro_authorized_by_id == AuthMethodEnum.SPLIT_AUTHORIZATION) {
      this.splitAuth(options, spec, mainEntry, forest);
    }
    if (spec.ro_authorized_by_id == AuthMethodEnum.RO_AUTHORIZED) {
      if (spec.approved_unit_cost != spec.unit_cost || spec.approved_unit_qty != (spec.custom_unit_qty ?? spec.gis_unit_qty)) {
        forest.data.push({
          rowType: "bonus-top",
          treatment: "Modified Authorization",
          treatment_option: options?.treatment_option,
          spec_number: spec.specification_number,
        }, {
          rowType: "bonus-data",
          treatment: "# of Units or Unit Cost Modified",
          treatment_option: options?.treatment_option,
          spec_number: spec.specification_number,
          unit_qty: spec.approved_unit_qty,
          unit_cost: spec.approved_unit_cost,
          qty_class: spec.approved_unit_qty == (spec.custom_unit_qty ?? spec.gis_unit_qty) ? undefined : 'yellow',
          cost_class: spec.approved_unit_cost == spec.unit_cost ? undefined : 'yellow',
          hideRequested: true,
          approved_unit_qty: spec.approved_unit_qty,
          approved_unit_cost: spec.approved_unit_cost,
        })
      }
    }
  }

  splitAuth(options: any, spec: any, mainEntry: any, forest: any) {

    let items = [
      {
        rowType: "bonus-top",
        treatment: "Split Authorization",
        treatment_option: options?.treatment_option,
        spec_number: spec.specification_number,
      },
      {
        rowType: "bonus-data",
        treatment: "RO Split Authorization",
        treatment_option: options?.treatment_option,
        spec_number: spec.specification_number,
        unit_qty: spec.custom_unit_qty ?? spec.gis_unit_qty,
        unit_cost: spec.unit_cost,
        approved_unit_qty: spec.approved_unit_qty,
        approved_unit_cost: spec.approved_unit_cost,
        cost_class: spec.approved_unit_cost == spec.unit_cost ? undefined : 'yellow',
      },
      {
        rowType: "bonus-data bonus-data-end",
        treatment: "WO Split Authorization",
        treatment_option: options?.treatment_option,
        spec_number: spec.specification_number,
        unit_qty: spec.custom_unit_qty ?? spec.gis_unit_qty,
        unit_cost: spec.unit_cost,

        // show wo approved unit qty, but if not approved yet, show difference in requested - re approved
        wo_approved_unit_qty: spec.wo_approved_unit_qty || ((spec.custom_unit_qty ?? spec.gis_unit_qty) - spec.approved_unit_qty),
        wo_approved_unit_cost: spec.wo_approved_unit_cost,

        // highlight yellow differences between expected and approved
        qty_class: spec.wo_approved_unit_qty && spec.wo_approved_unit_qty != ((spec.custom_unit_qty ?? spec.gis_unit_qty) - spec.approved_unit_qty) ? 'yellow' : undefined,
        cost_class: spec.wo_approved_unit_cost && spec.wo_approved_unit_cost != spec.unit_cost ? 'yellow' : undefined,
      }
    ]
    let woEntry = { ...mainEntry }
    woEntry.select = new FormControl(false)
    woEntry.zeroRequested = true // hide requested funds on WO
    forest.data.push(...items)
    forest.woData.push(woEntry, ...items)
  }

  unitTotal(item: any, allow?: boolean) {
    if (!allow && item.rowType != "normal-cell") return 0
    if (item.zeroRequested) return 0
    return item.unit_cost * item.unit_qty;
  }
  unitTotalAuthorized(item: any) {
    if (item.rowType != "normal-cell") return 0
    return item.approved_unit_qty * item.approved_unit_cost;
  }
  unitTotalWOAuthorized(item: any) {
    if (item.rowType != "normal-cell") return 0
    return (item.wo_approved_unit_qty * item.wo_approved_unit_cost);
  }

  forestTotal(data: any[]) {
    let total = 0;
    if (data == null) return 0
    for (let item of data) {
      total += this.unitTotal(item) || 0; // ?? Does not cover NaN
    }
    return total;
  }

  forestTotalAuthorized(data: any[]) {
    let total = 0;
    if (data == null) return 0
    for (let item of data) {
      total += this.unitTotalAuthorized(item) || 0; // ?? Does not cover NaN
    }
    return total;
  }
  forestWOTotalAuthorized(data: any[]) {
    let total = 0;
    if (data == null) return 0
    for (let item of data) {
      total += this.unitTotalWOAuthorized(item) || 0; // ?? Does not cover NaN
    }
    return total;
  }

  editFunding(item: any, type: string) {
    this.titleService.setTitle("BAER - Regional-funding-edit")
    this.dialog.open(EditFundsComponent, {
      width: '100vw',
      maxWidth: "1000px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        spec: item,
        type: type //RO/WO
      },
    }).afterClosed().subscribe((reload) => {
      this.titleService.setTitle("BAER - Regional-funding")
      if (reload) {
        this.updateReportSubject?.next(null)
      }
    })

  }

  checkIfAllComplete() {
    let allComplete = true
    this.report().forests.forEach((forest: ReportForest & ReportForestExtras) => {
      forest.data.forEach((item: any) => {
        if (item.rowType == "normal-cell") {
          if (item.ro_authorized_by_id === null) {
            allComplete = false
          }
        }
      })
    });
    for (let region of this.getRequestedFundsRegions()) {
      if (this.regionExceedsValue(region, this.totalRequested[region])) {
        allComplete = false
      }
    }
    this.readySubject.next(allComplete)
  }


  getAuthStatusText(id: any) {
    if (this.authorizationStatusList == null) return
    return this.authorizationStatusList[id].text
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replaceAll(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.codePointAt(0) + ';';
    }));
  }

  tooltip(item: any) {
    let text = ""
    for (let id of item.authorization_status_ids ?? []) {
      if (text != "") text += "\n\n"
      text += this.getAuthStatusText(id)
    }
    if (text != "") text += "\n\n"
    text += ((item.authorization_note) ?? '')
    return text
  }

  getRequestedFundsRegions() {
    return Object.keys(this.totalRequested)
  }

  regionMaxFunds(region: string): number {
    if (["08", "09", "10"].includes(region)) {
      return 100000
    }
    return 500000
  }

  regionExceedsValue(region: string, funds: number): boolean {
    let maxFunds = this.regionMaxFunds(region)
    return funds > maxFunds
  }

  getForestsInRegion(region: string): string {
    let forestList = this.report().forests.filter((forest: ReportForest) => forest.region == +region)
    return forestList.map((forest: ReportForest) => forest.forest_name).join(" and ")
  }

  quickConfirm(item: any): Promise<void> {
    let promise = new Promise<void>((resolve, reject) => {
      let data = {
        fully_funded: true,
        approved_unit_cost: item.unit_cost,
        approved_unit_qty: item.unit_qty,
        ro_authorized_by_id: 0,
      }
      this.reportService.editSpec(data, item.treatment_specification_id).subscribe({
        next: (response) => {
          resolve()
        },
        error: (err) => {
          reject(new Error(err))
        },
      })
    })
    return promise
  }

  fullyFunded(item: any) {
    this.quickConfirm(item).then((result) => {
      this.toast.openSuccessSnackBar(`The treatment(s) have been authorized.`);
    }).catch((error: any) => {
      console.log(error)
      this.toast.openErrorSnackBar(`There was an error updating the treatments.`, "Please try again.");
    }).finally(() => {
      this.updateReportSubject?.next(null)
    })
  }

  selectCheck(item: any) { //triggered by checkbox click
    this.ref.detectChanges()
    this.openSnackBar();
  }

  openSnackBar() {
    let selectedItems: any[] = []
    this.report().forests.forEach((forest: any) => {
      forest.data.forEach((item: any) => {
        if (item.select?.value) {
          selectedItems.push(item)
        }
      })
      forest.woData.forEach((item: any) => {
        if (item.select?.value) {
          selectedItems.push(item)
        }
      })
    })
    if (selectedItems.length > 0) {
      let subject = new Subject()
      this._snackBar.openFromComponent(QuickConfirmSnackbarComponent, {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        data: {
          length: selectedItems.length,
          items: selectedItems.length,
          subject: subject
        }
      })
      subject.asObservable().subscribe(confirm => {
        if (confirm) {
          let promisesAll: Promise<void>[] = []
          selectedItems.forEach((item: any) => {
            promisesAll.push(this.quickConfirm(item))
          })
          Promise.all(promisesAll).then((result) => {
            this.toast.openSuccessSnackBar(`The treatment(s) have been authorized.`);
          }).catch((error: any) => {
            console.log(error)
            this.toast.openErrorSnackBar(`There was an error updating the treatments.`, "Please try again.");
          }).finally(() => {
            this.updateReportSubject?.next(null)
          })
        } else {
          this.report().forests.forEach((forest: any) => {
            forest.data.forEach((item: any) => {
              item.select?.patchValue(false)
            })
            forest.woData.forEach((item: any) => {
              item.select?.patchValue(false)
            })
          })
        }
      })
    }
    else {
      this._snackBar.openFromComponent(QuickConfirmSnackbarComponent, {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        duration: 3000,
        data: {
          length: 0,
        }
      });
    }
  }

  selectAll(event: any, data: any[]) {
    data.forEach((item: any) => {
      item.select?.patchValue(event.target.checked)
    })
    this.openSnackBar()
  }

  output(item: any) {
    return item.rowType + ' ' + item.select?.value ? 'off-white' : ''
  }
}

@Component({
  selector: 'quick-confirm-snackbar',
  templateUrl: 'quick-confirm.html',
  styleUrls: ['./quick-confirm.component.scss'],
  standalone: false
})
export class QuickConfirmSnackbarComponent {
  length = this.data.length;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public dialog: MatDialog,
    private readonly titleService: Title
  ) { }
  snackBarRef = inject(MatSnackBarRef);

  confirm() {
    this.data.subject.next(true);
  }

  clearSelected() {
    this.data.subject.next(false);
  }
}